import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from '../services';
import KartyaGeneralasForm from './KartyaGeneralasForm';
import VasarloiKartyaForm from '../VasarloiKartya/VasarloiKartyaForm';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import moment from 'moment';
import FileSaver from 'file-saver';
import _ from 'lodash';
import KartyaGeneralasFilter from './KartyaGeneralasFilter';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';

function setFilter(filters) {
  this.setState({filters: filters})
}

class KartyaGeneralasContent extends Component {
  constructor(props) {
    super(props);

    this.state = {

      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      
      // DATA
      baseJson: [],
      childJson: [],
      expandedItems: [],
      selectedItems: [],
      selectedRow: null,
      viewObj: {},
      printURL: null,

      currentId: undefined,
      currentKartyaId: undefined,

      torlesId: undefined,
      torlesKartyaId: undefined,

      formTypeStatus: '',
      formKartyaTypeStatus: '',

      showFilter: false,

      // FORM GENERALAS
      formKartyaTipus: null,
      formPrefix: '',
      formMennyiseg: '',
      formMegjegyzes: '',

      // FORM RENEWAL
      formHosszabbitas: null,
      
      // MODALS
      modalView: false,
      modalDelete: false,
      modalForm: false,
      modalPartner: false,
      modalKartyaDelete: false,
      modalKartyaForm: false,
      modalKartyaRenewalForm: false,

      //BUTTONS
      saveButtonLoading: false,
      deleteButtonLoading: false,
      saveKartyaButtonLoading: false,
      deleteKartyaButtonLoading: false,
    };

    setFilter = setFilter.bind(this);
  }

  componentDidUpdate(prevProps) {
    if(this.props.active !== prevProps.active){
      if(this.props.active){
        //this.listKartyaGeneralas(this.state.filters);
      }
      this.setState({showFilter: this.props.active});
    }
  }

  componentWillUnmount() {
    this.setState({showFilter: false});
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }), () => {
      if(!this.state.modalForm){
        this.listKartyaGeneralas(this.state.filters);
      }
    });
  }

  toggleKartyaFormModal = () => {
    this.setState(prevState => ({ modalKartyaForm: !prevState.modalKartyaForm }), () => {
      if(!this.state.modalKartyaForm){
        this.loadVasarloiKartyaByGenId(this.state.selectedRow.id, this.state.selectedRow);
      }
    });
  }

  toggleKartyaRenewalFormModal = () => {
    this.setState(prevState => ({ modalKartyaRenewalForm: !prevState.modalKartyaRenewalForm }), () => {
      if(!this.state.modalKartyaRenewalForm){
        this.loadVasarloiKartyaByGenId(this.state.selectedRow.id, this.state.selectedRow);
      }
    });
  }

  toggleKartyaDeleteModal = () => {
    this.setState(prevState => ({ modalKartyaDelete: !prevState.modalKartyaDelete }), () => {
      if(!this.state.modalKartyaDelete){
        this.loadVasarloiKartyaByGenId(this.state.torlesKartyaId, this.state.selectedRow);
      }
    });
  }

  togglePartnerModal = () => {
    this.setState(prevState => ({ modalPartner: !prevState.modalPartner }));
  }

  onRowPartnerSelect = (partner, isSelected, e) => {
    if(isSelected){
      this.setState(() => ({ selectedPartner:  [partner]}));
    }else{
      this.setState(() => ({ selectedPartner:  []}));
    }
  }


  // API REQUESTS
  listKartyaGeneralas = (defaultFilters = {}) => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listKartyaGeneralas(this.state.filter || defaultFilters, (err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
            childJson: [],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  saveKartyaGeneralas = (e, submitObj) => {
    const {
      formTypeStatus
    } = this.state;
    const {
      formKartyaTipus,
      formMennyiseg,
      formMegjegyzes,
    } = submitObj;

    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formTypeStatus == 'FEL') {

        submitObj.kartyatipusid = formKartyaTipus.id;
        submitObj.mennyiseg = formMennyiseg;
        submitObj.megjegyzes = formMegjegyzes;

        Services.addKartyaGenerelas(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Kártyák generálása elkészült!');
            this.toggleFormModal();
            this.listKartyaGeneralas(this.state.filters);
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  deleteKartyaGeneralas = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteKartyaGeneralas(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listKartyaGeneralas(this.state.filters);
        this.props.globals.addSuccess('Kártya generálás törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  loadVasarloiKartyaByGenId = (id, row, closeModal) => {
    Services.listVasarloiKartyaByGeneralas(id, (err, res) => {
      if (!err) {
        this.setState({
          expandedItems: [{id: id, data: res[0]}],
          selectedItems: [],
          selectedRow: row,
          torlesKartyaId: null,
        }, () => {
          if(closeModal){
            closeModal();
          }
        });
      }
    });
  }

  deleteVasarloiKartya = () => {
    this.setState({
      deleteKartyaButtonLoading: true
    }, () => {
      Services.deleteVasarloiKartya(this.state.torlesKartyaId, (err) => {
        if (!err) {
          this.toggleKartyaDeleteModal();
          this.props.globals.addSuccess('Vásárlói kártya törölve!');
          this.setState({
            deleteKartyaButtonLoading: false
          });
        } else {
          this.setState({
            deleteKartyaButtonLoading: false
          });
        }
      });
    });
  }

  //GENERÁLÁS events
  handleViewItemsClick = (id, row) => {
    if (!this.state.expandedItems.find(x => x.id == id)) {
      this.loadVasarloiKartyaByGenId(id, row);
    } else {
      this.setState(() => ({
        expandedItems: this.state.expandedItems.filter(x => x.id !== id),
        selectedItems: [],
        selectedRow: null,
      }));
    }
  }

  handleNewClick = () => {
    this.setState({
      currentId: null,
      formStatus: 'DATA',
      formTypeStatus: 'FEL',
      formKartyaTipus: null,
      formPrefix: '',
      formMennyiseg: '',
      formMegjegyzes: '',
    }, () => this.toggleFormModal());
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  //KÁRTYA events

  isDate = (date) => {
    return date instanceof Date && !isNaN(date.valueOf());
  } 

  handleEditKartyaClick = (id, kartya) => {
    this.setState({
      currentKartyaId: id,
      aktivalas: !kartya.aktivalva
    }, () => {
      this.toggleKartyaFormModal();
    });
  }

  handleRenewalClick = () => {
    this.setState({
      formHosszabbitas: null,
    }, () => this.toggleKartyaRenewalFormModal());
  }

  handleExportClick = (kartya, full) => {
    const{
      selectedItems
    } = this.state;
    Services.exportKartyaGeneralas(kartya.id, full ? [] : selectedItems, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Csv fájl letöltés indítása...');
        const blob = new Blob([res[0]], { type: 'text/csv;charset=utf-8', responseType: 'arraybuffer' });
        const date = TimeFormatter.formatDate(new Date());
        FileSaver.saveAs(blob, 'AZONOSITO_GEN_' + date + '.csv');
      }
    });
  }

  handlePrintClick = () => {
    const{
      selectedItems
    } = this.state;

    Services.printVasarloiKartyaGroup(selectedItems, (err, res) => {
      if (!err) {
        let printURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          printURL 
        }, () => {
          window.setTimeout(() => {

            window.frames["pdf-area-vasarloikartya-group"].focus();
            window.frames["pdf-area-vasarloikartya-group"].print();
            window.setTimeout(() => {
            window.close();
            }, 50);
          }, 1000);
        })
        this.props.globals.addSuccess('Vásárlói kártya nyomtatás!');
      }
    });
  }

  handleDeleteKartyaClick = (id) => {
    this.setState({
      torlesKartyaId: id
    }, () => {
      this.toggleKartyaDeleteModal();
    });
  }


  // INPUT onchange

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    
    this.setState({
      [name]: value
    });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }


  // TABLE formatters

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment> 
          <Button className="icon-list table-action-icon" id={'action-view-' + cell + 'azonositok'} onClick={() => this.handleViewItemsClick(cell, row)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'azonositok'} delay={50}>
            {'Azonosítók'}
          </UncontrolledTooltip>
        </React.Fragment> 
        {this.props.globals.hasRole(['KEDVEZMENY_VKGEN'], true) && (
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>

            <Button className="icon-share-alt table-action-icon" id={'action-view-' + cell + 'exportalas'} onClick={() => this.handleExportClick(row, true)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'exportalas'} delay={50}>
              {'Exportálás'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  kartyaTableIconFormatter = (cell, row) => {
    return (
      <div>
        {this.props.globals.hasRole(['KEDVEZMENY_VKGEN'], true) && (
          <React.Fragment>
            {!row.aktivalva && (
              <React.Fragment>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete-azonosito'} onClick={() => this.handleDeleteKartyaClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete-azonosito'} delay={50}>
                  {'Törlés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {/* <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'edit-azonosito'} onClick={() => this.handleEditKartyaClick(cell, row)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'edit-azonosito'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip> */}
          </React.Fragment>
        )}
      </div>
    );
  }

  dateColumnFormatter = (cell) => {
    return cell ? TimeFormatter.formatDate(cell) : "";
  }

  dateTimeColumnFormatter = (cell) => {
    return cell ? TimeFormatter.formatDateTime(cell) : "";
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const optionsExpand = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const selectRow = {
      selected: this.state.selectedItems,
      mode: 'checkbox',
      clickToSelect: true,
      onSelect: this.onRowSelect,
      onSelectAll: this.onRowSelectAll,
      style: { backgroundColor: '#c8e6c9' },
      //style: { background: 'red' }
    }

    const columns = [
      {
        dataField: 'rogzitesIdopont',
        text: 'Generálás időpontja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: this.dateTimeColumnFormatter,
      },
      {
        dataField: 'kartyaTipusNev',
        text: 'Kártyatípus',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'mennyiseg',
        text: 'Mennyiség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'uvd.szemelynev',
        text: 'Generálta',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'megjegyzes',
        text: 'Megjegyzés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    const kartyaColumns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'datumok',
        text: 'Rögzítve/Megszemélyesítve/Kezdete',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell && (TimeFormatter.formatDateTime(cell.generalas) + 
                              " / "  + (cell.kezdete ? TimeFormatter.formatDateTime(cell.aktivalas) : "-") + 
                               " / " + (cell.kezdete ? TimeFormatter.formatDate(cell.kezdete): "-"))
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.kartyaTableIconFormatter
      }
    ];

    const expandRow = {
      renderer: row => ( this.state.expandedItems.find(x => x.id == row.id) &&
          <React.Fragment>
            <div className="row">
              <div className="col-md-2">
                <h5>Generált azonosítók</h5>
              </div>  
            </div>
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={this.state.expandedItems.find(x => x.id == row.id).data}
              columns={kartyaColumns}
              //selectRow={selectRow}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
              noDataIndication="Nincs megjelenítendő adat!"
            />
          </React.Fragment>
      ),
      expanded: this.state.expandedItems.map( x => x.id),
      expandByColumnOnly: true,
    };

    return (
      <React.Fragment>
        {this.renderButtons()}
        <div className="animated fadeIn">
          <BootstrapTable
            bootstrap4
            keyField="id"
            data={this.state.baseJson}
            columns={columns}
            expandRow={expandRow}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
      </React.Fragment>
    );
  }

  renderButtons = () => {
    return(
      <React.Fragment>
        {this.props.globals.hasRole(['KEDVEZMENY_VKGEN'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új azonosítók generálása'}
            </Button>
          )}
          <Button type="button" style={{verticalAlign: 'top', marginLeft: '50px'}} color="primary" onClick={() => this.listKartyaGeneralas(this.state.filters)}> 
            <span><i className="fa fa-search" aria-hidden="true"></i></span>
          </Button>
      </React.Fragment>  
    );
  }

  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listKartyaGeneralas(this.state.filters)}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderModals = () => {
    return(
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteKartyaGeneralas()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalKartyaDelete} toggle={this.toggleKartyaDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteVasarloiKartya()}
              loading={this.state.deleteKartyaButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleKartyaDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" >
          <RFForm
            modal
            onSubmit={this.saveKartyaGeneralas}
            title="Új azonosítók generálása"
            footer={
              <>
                <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getKartyaGeneralasForm(this.state.currentId)}
                />),
              DATA: 
                <KartyaGeneralasForm 
                  formKartyaTipus={this.state.formKartyaTipus}
                  formPrefix={this.state.formPrefix}
                  formMennyiseg={this.state.formMennyiseg}
                  formMegjegyzes={this.state.formMegjegyzes}
                  handleInputChange={this.handleInputChange}
                  handleSelectInputChange={this.handleSelectInputChange}
                />
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
     </React.Fragment>
    );
  }

  render = () => {
    const {
      showFilter,
      tableStatus,
    } = this.state;
    return (
      <React.Fragment>
        <iframe name="pdf-area-vasarloikartya-group" id="pdf-area-vasarloikartya-group" src={this.state.printURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
          {showFilter && <KartyaGeneralasFilter setFilter={setFilter}/>}
          {tableStatus != 'TABL' && this.renderButtons()}
        <div className="row">
          {this.renderTableView()}
        </div>
        {this.renderModals()}
        {this.state.modalKartyaForm && 
          <VasarloiKartyaForm 
            globals={this.props.globals}
            id={this.state.currentKartyaId}
            modositas
            aktivalas={this.state.aktivalas}
            toggleFormModal={this.toggleKartyaFormModal}
          />
        }
      </React.Fragment>
    );
  }
}

KartyaGeneralasContent.propTypes = {
  globals: PropTypes.object
};

export default KartyaGeneralasContent;
